<template>
  <main class="qr-code" :style="{ paddingTop: '30px' }">
    <van-empty v-if="showEmpty" description="券码不存在，请联系客服" />
    <template v-if="!showEmpty">
      <div class="showcode">
        <div class="showcode-main">
          <van-image
            lazy-load
            class="showcode-logo"
            fit="cover"
            :src="errorImage"
          />
          <div class="showcode-img" :style="{ marginTop: '30px' }">
            <qrcode-vue
              v-if="
                coupon_format === 'qr_code' || coupon_format === 'qr_bar_code'
              "
              :value="coupon_code + ''"
              :size="180"
              level="H"
            />
            <barcode
              v-if="
                coupon_format === 'bar_code' || coupon_format === 'qr_bar_code'
              "
              :value="coupon_code + ''"
              :width="1"
            >
              条形码生成失败，请联系客服
            </barcode>
          </div>
          <div class="showcode-tips">
            <span>{{ itemInfo.tips }}</span>
          </div>
          <div class="showcode-line">
            <span class="semicircle"></span>
            <span class="semicircle2"></span>
          </div>
          <div class="showcode-code">{{ coupon_code }}</div>
          <div class="showcode-explain">
            <div class="showcode-explain-title">- 使用条款 -</div>
            <div
              class="showcode-explain-content"
              v-replace.day="30"
              v-html="itemInfo.instruction"
            ></div>
          </div>
        </div>
      </div>
    </template>
  </main>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import Barcode from "vue-barcode";
import { getItemInfo } from "@/apis/home";
import errorImage from "@/assets/images/coupondefault.png";

export default {
  components: {
    QrcodeVue,
    Barcode,
  },
  data() {
    return {
      showEmpty: false,
      coupon_code: "",
      coupon_format: "",
      errorImage: errorImage,
      itemInfo: {},
    };
  },
  computed: {
    logo_url() {
      return errorImage;
    },
  },
  async mounted() {
    const { coupon_code, item_code, coupon_format, benefit_type } =
      this.$route.query;
    if (!coupon_code) {
      this.showEmpty = true;
      return;
    }
    const res = await getItemInfo({
      item_code,
      benefit_type,
      project_db: "oakvip",
    });
    this.itemInfo = res;
    this.item_code = item_code;
    this.coupon_code = coupon_code;
    this.coupon_format = coupon_format;
  },
};
</script>

<style lang="less" scoped>
.qr-code {
  padding: 40px 0;
}
.showcode-main {
  background-color: #fff;
  margin: 0 15px;
  border-radius: 8px;
  position: relative;
  padding: 1px 0;
}
.showcode-logo {
  position: absolute;
  width: 44px;
  height: 44px;
  background-color: #fff;
  border-radius: 50%;
  overflow: hidden;
  left: 50%;
  top: 0;
  transform: translate(-50%, -50%);
}
.showcode-img {
  margin: 45px auto 0;
  text-align: center;
}
.showcode-name {
  text-align: center;
  font-size: @font-md;
  margin-top: 7px;
  font-weight: bold;
  line-height: 22px;
}
.showcode-code {
  text-align: center;
  font-size: @font-xs;
  color: @text-gray-color;
  margin-top: 2px;
  line-height: 20px;
}
.showcode-tips {
  text-align: center;
  margin-top: 10px;
}
.showcode-line {
  border-bottom: 1px dashed #ccc;
  position: relative;
  margin-top: 20px;
}
.semicircle {
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
}
.semicircle2 {
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
}

.showcode-explain {
  margin: 20px;
}
.showcode-explain-title {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
}
.showcode-explain-content {
  color: @text-gray2-color;
  margin-top: 15px;
  white-space: pre-wrap;
  line-height: 1.5;
}
</style>